export const routes = {
    "/actions": {
        title: "Outstanding Actions",
        "/:ohCaseId/:taskId/ppq": {
            title: "PPQ"
        },
        "/:ohCaseId/:reviewReportTaskId/review-referral-report": {
            title: "Review Referral Report"
        },
        "/:ohCaseId/:reviewReportTaskId/review-old-referral-report/1": {
            title: "Review Referral Report"
        },
        "/:ohCaseId/:reviewReportTaskId/review-mhp-treatment-report": {
            title: "Review MHP Treatment Report"
        },
        "/:ohCaseId/:reviewReportTaskId/review-ppq-certificate": {
            title: "Review PPQ Certificate"
        },
        "/:ohCaseId/:taskId/choose-and-book": {
            title: "Choose and Book"
        },
        "/:ohCaseId/:taskId/healthSurveillanceQuestionnaire": {
            title: "Health Surveillance Questionnaire"
        },
        "/:ohCaseId/:reviewReportTaskId/review-physiotherapy-referral-report": {
            title: "Review Physiotherapy Referral Report"
        },
        "/:ohCaseId/:taskId/view-shared-documents": {
            title: "View Shared Documents"
        },
        "/:ohCaseId/:taskId/sra": {
            title: "Stress Risk Assessment"
        },
        "/customer/:customerId/ohCase/:ohCaseId/stressriskassessmentresults": {
            title: "Stress Risk Assessment"
        }
    }
};
